import React from 'react';
import './Home.css';
import { Link } from "react-router-dom";

import ASCIIComputer from '../Images/ascii-computer.png';

function Home() {
  return (
    <div className="home-container">
      <h1 className="typing">hello world</h1>
      <p>
        Welcome to my personal blog. This is where I will update on my tech advancements and projects.
        <p>Check out my first blog below!</p>
      </p>

      <div className="blog-cards">
        <Link to="/homelab">
        <div className="hp-blog-container">
          <p>My Homelab Build</p>
          <div className="ascii-computer">
            <img src={ASCIIComputer} alt="ASCII Computer" />
          </div>
        </div>
        </Link>
      </div>

    </div>
  );
}

export default Home;
